<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Dacr Timestamps</template>

    <Sheet.Body>
      <RegistrationsBody :file="file" />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'
import type { File } from '@/shared/graphql/router/graphql'
import RegistrationsBody from './RegistrationsBody.vue'

defineProps<{
  file: File
}>()

const { close } = useSheet()
</script>
